export function getCurrentScrollTop ({ document, window }) {
  if (document.documentElement?.classList.contains('over-hidden')) {
    return document.body?.scrollTop || 0
  }
  return window.scrollY || window.pageYOffset || 0
}

export function createPopupScrollLock ({
  document,
  window,
  requestFrame = cb => window.requestAnimationFrame ? window.requestAnimationFrame(cb) : setTimeout(cb, 0),
  setDelay = cb => setTimeout(cb, 80)
}) {
  const state = {
    isPopupOpen: false,
    scrollTop: 0,
    transitionId: 0
  }

  function getHtml () {
    return document.documentElement || document.getElementsByTagName('html')[0]
  }

  function isBodyLocked (classValue) {
    return String(classValue || '').split(' ').includes('el-popup-parent--hidden')
  }

  function lock () {
    if (!state.isPopupOpen) {
      state.scrollTop = getCurrentScrollTop({ document, window })
    }
    state.transitionId += 1
    state.isPopupOpen = true
    getHtml()?.classList.add('over-hidden')
    document.body?.scrollTo?.(0, state.scrollTop)
  }

  function unlock () {
    const unlockId = state.transitionId
    requestFrame(() => {
      requestFrame(() => {
        setDelay(() => {
          if (unlockId !== state.transitionId || document.body?.classList.contains('el-popup-parent--hidden')) {
            return
          }
          state.isPopupOpen = false
          getHtml()?.classList.remove('over-hidden')
          window.scrollTo(0, state.scrollTop)
        })
      })
    })
  }

  return {
    sync (classValue) {
      if (isBodyLocked(classValue)) {
        lock()
      } else if (state.isPopupOpen) {
        unlock()
      }
    },
    reset () {
      state.transitionId += 1
      state.isPopupOpen = false
      getHtml()?.classList.remove('over-hidden')
    },
    getState () {
      return { ...state }
    }
  }
}

export default createPopupScrollLock
